/* HoD CRO (WP CRO, 30 Sep 2026; Fixer C 1 Oct 2026). Three independent jobs, no theme-bundle dependency:
   1. [data-hod-shipbar]: the free shipping bar (AU $149 / NZ NZ$199, inclusive: snippets/hod-ship-threshold.liquid).
      Recomputed from cart.total_price on every cart change
      (theme events cart:updated / ajaxProduct:added / cart:open, plus a /cart.js fetch when an event has no cart).
   2. [data-hod-vband]: the home video band. The MP4 is attached only after window load, only when the band is near
      the viewport, never with prefers-reduced-motion or Save-Data; it fades in over the still, pauses off-screen,
      and the pause/play button is the user's override (a user pause is never undone by scrolling).
      P70 (R1): on phones nothing loads until a tap on "Play film" (unless the section's phone_autoplay is on).
   3. [data-hod-dispatch]: the PDP dispatch line (snippets/hod-fold-trust.liquid). Orders before 12pm Melbourne time
      (Australia/Melbourne, daylight-saving aware; the warehouse is in Melbourne) on a business day usually ship the
      same day, so the line reads "today" before the cut-off, otherwise the next business day ("tomorrow" or the
      weekday name). Weekends plus the 2026-2027 national and Victorian public holidays (HOLIDAYS below) are skipped,
      so it never promises "today" on a holiday. Extend the list before 2028. The words stay "usually". The delivery
      days narrow to the visitor's state when the browser time zone names one (the table on
      /pages/shipping-returns); otherwise the AU range. */
(function () {
  'use strict';

  /* ---------- 1. shipping bar ---------- */
  // 2 Oct tidy: plain "$" in every market, the same as the money filter on every other price in the bag (REG-03).
  var fmt = function (cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };

  // 2 Oct tidy: only lines that ship count toward free shipping (a gift card cannot unlock it), and nothing-ships
  // carts hide the bar and the shipping lines. Mirrors snippets/hod-upsell-shipbar.liquid and sections/main-cart.liquid.
  function shipState(c) {
    var total = c.total_price;
    var ships = c.requires_shipping !== false;
    // N11 / D14 (R1): theme setting ship_bar_gift_cards = include puts data-gc-counts on the bar; then gift-card lines count
    var gcCounts = !!document.querySelector('[data-hod-shipbar][data-gc-counts], [data-hod-ship-note][data-gc-counts]');
    if (!gcCounts && c.items && c.items.length) {
      for (var k = 0; k < c.items.length; k++) {
        var it = c.items[k];
        if (it.requires_shipping === false) total -= it.final_line_price || 0;
      }
    }
    if (!c.item_count) ships = true;
    return { total: Math.max(0, total), ships: ships };
  }

  // P21 (R2): the drawer / cart BNPL line ([data-hod-bnpl], snippets/hod-bnpl-line.liquid) follows the cart total:
  // a quarter of cart.total_price, shown only between $20 and the Afterpay maximum (data-max, cents).
  function paintBnpl(c) {
    var lines = document.querySelectorAll('[data-hod-bnpl]');
    for (var b = 0; b < lines.length; b++) {
      var el = lines[b], max = parseInt(el.getAttribute('data-max'), 10) || 200000, t = c.total_price || 0;
      var ok = t >= 2000 && t <= max;
      el.hidden = !ok;
      var a = el.querySelector('[data-hod-bnpl-amt]');
      if (ok && a) { var q = Math.floor(t / 4); a.textContent = '$' + (q / 100).toFixed(2); }
    }
  }

  function paintCart(c) {
    paintBnpl(c);
    var st = shipState(c);
    var only = document.querySelectorAll('[data-hod-shipbar], [data-hod-ship-only]');
    for (var m = 0; m < only.length; m++) only[m].hidden = !st.ships;
    paint(st.total, st.ships);
  }

  function paint(total, ships) {
    var bars = document.querySelectorAll('[data-hod-shipbar]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var t = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!t) continue;
      var left = t - total;
      var region = bar.getAttribute('data-region') || 'Australia';
      var incl = bar.hasAttribute('data-inclusive'); // AU $149 and NZ NZ$199 are both inclusive
      var done = incl ? total >= t : total > t;
      var pct = Math.max(0, Math.min(100, Math.floor((total * 100) / t)));
      if (!done && pct > 96) pct = 96; // never a full bar that has not qualified
      var msg;
      if (done) msg = 'Your order ships free within ' + region + '.';
      else if (incl) msg = 'Add ' + fmt(left) + ' more for free standard shipping to ' + region + '.';
      else if (left > 0) msg = 'Add over ' + fmt(left) + ' more for free standard shipping in ' + region + '.';
      else msg = 'Add one more piece for free standard shipping in ' + region + ' (orders over ' + (bar.getAttribute('data-limit') || fmt(t)) + ').';
      var text = bar.querySelector('[data-hod-shipbar-text]');
      var fill = bar.querySelector('[data-hod-shipbar-fill]');
      var track = bar.querySelector('[data-hod-shipbar-track]');
      if (text && text.textContent !== msg) text.textContent = msg;
      if (fill) fill.style.transform = 'scaleX(' + pct / 100 + ')';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      bar.classList.toggle('is-done', done);
    }
    // the cart page's one shipping line agrees with the bar (sections/main-cart.liquid)
    var notes = document.querySelectorAll('[data-hod-ship-note]');
    for (var j = 0; j < notes.length; j++) {
      var n = notes[j];
      var nt = parseInt(n.getAttribute('data-threshold'), 10);
      if (!nt && ships !== false) continue;
      var nm = ships === false ? n.getAttribute('data-noship') : (n.hasAttribute('data-inclusive') ? total >= nt : total > nt) ? n.getAttribute('data-free') : n.getAttribute('data-paid');
      if (nm && n.textContent !== nm) n.textContent = nm;
    }
  }

  var pending = 0;
  function refetch() {
    if (!window.fetch || !document.querySelector('[data-hod-shipbar], [data-hod-ship-note]')) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.total_price === 'number') paintCart(c); })
        .catch(function () {});
    }, 150);
  }

  function onCart(e) {
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.total_price === 'number' && c.items) paintCart(c);
    else refetch();
  }
  ['cart:updated', 'cart:refresh', 'cart:open', 'ajaxProduct:added'].forEach(function (n) {
    document.addEventListener(n, onCart);
  });
  // 2 Oct tidy: no NZ repaint on load any more; the Liquid bar already prints the same plain "$" the JS does.

  /* ---------- 2. video band ---------- */
  function initBand(band) {
    var video = band.querySelector('[data-hod-vband-video]');
    var btn = band.querySelector('[data-hod-vband-toggle]');
    if (!video) return;
    var mqReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var saveData = navigator.connection && navigator.connection.saveData;
    if ((mqReduce && mqReduce.matches) || saveData || !('IntersectionObserver' in window)) return;

    var attached = false;
    var userPaused = false;
    var inView = false;
    // P70 (R1, 3 Oct 2026): on phones (< 750px) the still stays and nothing is downloaded until the visitor taps
    // "Play film" (about 2.4 MB saved per phone visit). Section setting phone_autoplay restores autoplay.
    var tapToPlay = !band.hasAttribute('data-hod-vband-phone-autoplay') &&
      !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);

    function setState(playing) {
      band.classList.toggle('is-paused', !playing);
      if (btn) btn.setAttribute('aria-label', playing ? 'Pause film' : 'Play film'); // name starts with the visible label (a11y label-content-name-mismatch, 15 Oct)
    }
    function tryPlay() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { setState(false); });
    }
    function attach() {
      if (attached) return;
      attached = true;
      video.src = video.getAttribute('data-src');
      video.addEventListener('playing', function () {
        band.classList.add('is-playing');
        setState(true);
        if (btn) btn.hidden = false;
      });
      video.addEventListener('pause', function () { setState(false); });
      tryPlay();
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (!attached) { userPaused = false; band.classList.remove('hod-vband--tap'); attach(); return; }
        if (video.paused) { userPaused = false; tryPlay(); }
        else { userPaused = true; video.pause(); }
      });
    }

    if (tapToPlay) {
      if (!btn) return;
      band.classList.add('hod-vband--tap');
      setState(false);
      btn.hidden = false;
    }

    var io = new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView) {
        if (!attached) { if (!tapToPlay) attach(); }
        else if (!userPaused && video.paused) tryPlay();
      } else if (attached && !video.paused) {
        video.pause();
      }
    }, { rootMargin: '200px 0px' });
    io.observe(band);

    if (mqReduce && mqReduce.addEventListener) {
      mqReduce.addEventListener('change', function (e) { if (e.matches && attached) { userPaused = true; video.pause(); } });
    }
  }

  function start() {
    var bands = document.querySelectorAll('[data-hod-vband]');
    for (var i = 0; i < bands.length; i++) initBand(bands[i]);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();

(function () {
  'use strict';
  /* ---------- 3. dispatch line ---------- */
  var lines = document.querySelectorAll('[data-hod-dispatch]');
  if (!lines.length || !window.Intl || !Intl.DateTimeFormat) return;
  /* National + Victorian public holidays (Melbourne dispatch), incl. VIC substitute days. AFL Grand Final eve 2027
     assumes the usual last-Saturday-of-September final; check it when the AFL fixes the date. */
  var HOLIDAYS = [
    '2026-01-01', '2026-01-26', '2026-03-09', '2026-04-03', '2026-04-04', '2026-04-06', '2026-06-08',
    '2026-09-25', '2026-11-03', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-01-26', '2027-03-08', '2027-03-26', '2027-03-27', '2027-03-29', '2027-06-14',
    '2027-09-24', '2027-11-02', '2027-12-27', '2027-12-28'
  ];
  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
  } catch (e) { return; }
  var y = 0, m = 0, dd = 0, hour = 0;
  parts.forEach(function (p) {
    if (p.type === 'year') y = parseInt(p.value, 10);
    if (p.type === 'month') m = parseInt(p.value, 10);
    if (p.type === 'day') dd = parseInt(p.value, 10);
    if (p.type === 'hour') hour = parseInt(p.value, 10) % 24;
  });
  if (!y || !m || !dd) return;
  var NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function isBusiness(dt) { var wd = dt.getUTCDay(); return wd > 0 && wd < 6 && HOLIDAYS.indexOf(iso(dt)) < 0; }
  var today = new Date(Date.UTC(y, m - 1, dd)); // the Melbourne calendar date, held as a UTC date
  var when;
  if (isBusiness(today) && hour < 12) {
    when = 'Order by 12pm Melbourne time, usually ships today';
  } else {
    var next = new Date(today.getTime()), n = 0;
    do { next = new Date(next.getTime() + 864e5); n++; } while (!isBusiness(next) && n < 14);
    when = 'Order now, usually ships ' + (n === 1 ? 'tomorrow' : NAMES[next.getUTCDay()]);
  }
  var zone = '';
  try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
  var STATES = {
    'Australia/Melbourne': 'VIC delivery 1–3 business days',
    'Australia/Sydney': 'NSW and ACT delivery 2–5 business days',
    'Australia/Canberra': 'ACT delivery 2–5 business days',
    'Australia/Adelaide': 'SA delivery 2–5 business days',
    'Australia/Brisbane': 'QLD delivery 2–7 business days',
    'Australia/Lindeman': 'QLD delivery 2–7 business days',
    'Australia/Hobart': 'TAS delivery 3–6 business days',
    'Australia/Perth': 'WA delivery 4–8 business days',
    'Australia/Darwin': 'NT delivery 5–10 business days'
  };
  for (var i = 0; i < lines.length; i++) {
    var w = lines[i].querySelector('[data-hod-dispatch-when]');
    if (w && when && w.textContent !== when) w.textContent = when;
    var d = lines[i].querySelector('[data-hod-dispatch-days]');
    if (d && lines[i].getAttribute('data-region') === 'AU' && STATES[zone]) d.textContent = STATES[zone];
  }
})();

/* ---------- 4. PDP thumbnails: one tab stop (R2-B, 2 Oct 2026; UX-DEVICE D-P4) ----------
   The gallery renders every media thumbnail as a link (up to 24), so keyboard users tabbed through all of them,
   with no visible focus, before reaching the main Add to bag. Now only the active thumbnail is a tab stop (roving
   tabindex); the arrow keys move between thumbnails and Enter picks one (the theme's own click handler). The
   slideshow's Next/Previous buttons are untouched. The focus ring is in assets/hod-cro.css. */
(function () {
  'use strict';
  function setup(wrap) {
    if (wrap.__hodThumbs) return;
    wrap.__hodThumbs = true;
    var scroller = wrap.querySelector('[data-thumb-scroller]');
    function all() { return Array.prototype.slice.call(wrap.querySelectorAll('a[data-product-thumb]')); }
    function shown() { return all().filter(function (a) { return a.offsetParent !== null; }); }
    function rove(target) {
      var list = shown();
      if (!list.length) return;
      var cur = target;
      if (!cur) {
        for (var i = 0; i < list.length; i++) {
          var it = list[i].closest('.product__thumb-item');
          if (it && it.classList.contains('is-active')) { cur = list[i]; break; }
        }
      }
      cur = cur || list[0];
      all().forEach(function (a) { a.setAttribute('tabindex', a === cur ? '0' : '-1'); });
      if (scroller) scroller.setAttribute('tabindex', '-1');
    }
    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; rove(); });
    }
    rove();
    if ('MutationObserver' in window) {
      new MutationObserver(queue).observe(wrap, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }
    wrap.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'Home' && k !== 'End') return;
      var a = e.target && e.target.closest ? e.target.closest('a[data-product-thumb]') : null;
      if (!a) return;
      var list = shown(), i = list.indexOf(a);
      if (i < 0) return;
      var n = (k === 'ArrowRight' || k === 'ArrowDown') ? i + 1 : (k === 'ArrowLeft' || k === 'ArrowUp') ? i - 1 : (k === 'Home' ? 0 : list.length - 1);
      n = Math.max(0, Math.min(list.length - 1, n));
      e.preventDefault();
      rove(list[n]);
      list[n].focus();
    });
    wrap.addEventListener('focusin', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-product-thumb]') : null;
      if (a && a.getAttribute('tabindex') !== '0') rove(a);
    });
  }
  function init() { document.querySelectorAll('[data-product-thumbs]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();

/* Pair bundle (4 Oct 2026): "Make it a pair" in the bag swaps the single lounger line for the Pair bundle. Capture phase:
   remove the single line first (cart/change, quantity 0), then hand the click to the theme's normal upsell add, which adds
   the bundle variant and rebuilds the drawer. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-hod-pair-swap]') : null;
    if (!b || b.getAttribute('data-hod-swapped') === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    b.classList.add('btn--loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: b.getAttribute('data-hod-pair-swap'), quantity: 0 })
    }).then(function (r) {
      b.classList.remove('btn--loading');
      if (!r.ok) throw new Error('change ' + r.status);
      b.setAttribute('data-hod-swapped', '1');
      b.click();
    }).catch(function () {
      b.classList.remove('btn--loading');
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }, true);
})();
